//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'NexusCSpine',
  data() {
    return {
      form: {
        postMidCervTenderness: '0',
        normalAlertness: '0',
        noIntoxication: '0',
        noAbnormalNeuro: '0',
        noPainDistracting: '0',
      },
      hasScore: false,
      disabled: false,
      defaultJson: {
        "No evidence of intoxication": "无中毒证据",
        "No abnormal neurologic findings": "无神经系统阳性发现",
        "C-Spine Xray indicated": "建议颈椎摄片",
        "No painful distracting injuries": "无疼痛性创伤",
        "C-Spine Xray not indicated": "无需颈椎摄片",
        "Normal level of alertness": "神志清醒",
        "Absence of posterior midline cervical tenderness": "颈部后正中线柔软度消失"
      },
    }
  },
  created() {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad']),
  },
  computed: {
    /** 计算主要标准 */
    score() {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
            form[key] = 0
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      // postMidCervTenderness + normalAlertness + noIntoxication + noAbnormalNeuro + noPainDistracting
      let result = form.postMidCervTenderness + form.normalAlertness + form.noIntoxication + form.noAbnormalNeuro + form.noPainDistracting
      self.hasScore = true
      return String(result)
    },
  },


}



// WEBPACK FOOTER //
// ./src/pages/formulas/Trauma/NexusCSpine.vue